/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} MonthlyInputs */

const en_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly`)
};

const es_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensual`)
};

const fr_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensuel`)
};

const de_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monatlich`)
};

const ja_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月額`)
};

const zh_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按月`)
};

const ar_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شهرياً`)
};

const id_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bulanan`)
};

const it_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensile`)
};

const ru_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ежемесячно`)
};

const pt_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensal`)
};

const ko_monthly = /** @type {(inputs: MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`월간`)
};

/**
* | output |
* | --- |
* | "Monthly" |
*
* @param {MonthlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const monthly = /** @type {((inputs?: MonthlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MonthlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monthly(inputs)
	if (locale === "es") return es_monthly(inputs)
	if (locale === "fr") return fr_monthly(inputs)
	if (locale === "de") return de_monthly(inputs)
	if (locale === "ja") return ja_monthly(inputs)
	if (locale === "zh") return zh_monthly(inputs)
	if (locale === "ar") return ar_monthly(inputs)
	if (locale === "id") return id_monthly(inputs)
	if (locale === "it") return it_monthly(inputs)
	if (locale === "ru") return ru_monthly(inputs)
	if (locale === "pt") return pt_monthly(inputs)
	return ko_monthly(inputs)
});